// extracted by mini-css-extract-plugin
module.exports = {"subtext":"FormikInput_subtext__3IlQI","error_text":"FormikInput_error_text__2Iutg"};